export const IMAGE_SELECTOR = 'img';
export const IMAGE_CONTAINER_SELECTOR = '.img__container-one';
export const IMAGE_INNER_BORDER_SELECTOR = '.img__inner-border';
